<template>
  <div class="acmper">
    <!-- 顶部按钮 -->
    <div style="padding:0 20px">
      <button class="buttons" style="margin-right:20px;background-color: brown;" @click="toBrack()">{{
        returnButtonValue
      }}</button>
      <button v-show="team_type == 1" class="buttons" style="background-color: #ee0a24;" @click="toSkip()">返回全员</button>
      <button class="buttons " style="width:35%;float: right;background-color:coral;" @click="skipWork()">工作人员</button>
    </div>
    <!-- /顶部按钮 -->

    <!-- 中队长显示 -->
    <div style="padding:20px ;font-size:15px;font-weight:700">
      <span style="margin-right:10px;">{{ team2_info.name }}</span>
      <span>{{ team2_info.captain_name || '暂无队长' }}</span>
      <span style="margin-left:10px;color:#ee0a24" @click="onMobile(team2_info.captain_mobile)">{{
        team2_info.captain_mobile || '暂无手机号'
      }}</span>
      <span style="margin-left:10px;">实到 <span style="color:#ee0a24">{{ team2_info.actual_num }}</span>人</span>
    </div>
    <!-- /中队长显示 -->

    <!-- 小队长显示 -->
    <div style=" padding:0 20px;font-size:15px;font-weight:700;padding-bottom: 7px">
      <span style="margin-right:10px;">{{ team3_info.name }}</span>
      <span>{{ team3_info.captain_name || '暂无队长' }}</span>
      <span style="margin-left:10px;color:#ee0a24" @click="onMobile(team3_info.captain_mobile)">{{
        team3_info.captain_mobile || '暂无手机号'
      }}</span>
      <span style="margin-left:10px;">实到 <span style="color:#ee0a24">{{ team3_info.actual_num }}</span>人</span>
    </div>
    <!-- /小队长显示 -->

    <!-- 表 -->
    <div class="gundong ">
      <div :style="{ width: clothesShow ? '140%' : '110%' }">
        <van-row>
          <van-col :span="clothesShow ? '1' : '2'" class="text-center">序号</van-col>
          <van-col :span="clothesShow ? '3' : '4'" class="text-center" @click="copyName()">
            <span>姓名</span>
            <van-icon style="vertical-align: bottom;" name="bill" size="15" color="#1989fa" />
          </van-col>
          <van-col span="2" class="text-center">吃药</van-col>
          <van-col :span="clothesShow ? '1' : '2'" class="text-center">性别</van-col>
          <van-col :span="clothesShow ? '3' : '4'" class="text-center">房间</van-col>
          <van-col span="2" class="text-center" v-show="clothesShow">营服</van-col>
          <van-col span="2" class="text-center" v-show="clothesShow">身高</van-col>
          <van-col span="2" class="text-center" v-show="clothesShow">体重</van-col>
          <van-col :span="clothesShow ? '4' : '5'" class="text-center">电话</van-col>
          <van-col :span="clothesShow ? '4' : '5'" class="text-center">渠道</van-col>
        </van-row>

        <!-- /表 -->

        <div style="margin-top:5px">
          <div v-for="(item, index) in List" :key="index" class="border-ls">
            <van-row type="flex" style="margin-top:5px">
              <van-col :span="clothesShow ? '1' : '2'" class="text-center line-h20">
                <van-icon v-if="item.is_birthday" name="point-gift" color="red" size="18"
                  @click="onBirthday(item.birthday)" />
                <span v-else>{{ index + 1 }}</span>

              </van-col>
              <van-col :span="clothesShow ? '3' : '4'" class="text-center line-h20"
                @click="item.issue_num > 0 ? onAbnormalSearch(item) : ''">
                {{ item.real_name }}
                <van-tag :class="item.issue_num > 0 ? '' : 'vhd'" type="danger" round>{{ item.issue_num }}</van-tag>

              </van-col>
              <van-col span="2" class="text-center" @click="onTakePills(item)">
                <van-image width="25" height="25"
                  :src="item.drug_remark ? $mAssetsPath.jiaoNang : $mAssetsPath.jiaoNangNo" />
              </van-col>
              <van-col :span="clothesShow ? '1' : '2'" class="text-center line-h20">{{ item.sex == 'man' ? '男' : '女' }}
              </van-col>
              <van-col :span="clothesShow ? '3' : '4'" class="text-center">
                <span v-show="roomDisabled" class="line-h20">
                  {{ item.room || '暂无' }}
                </span>
                <input @focus="$event.target.select()" v-show="!roomDisabled" type="text" v-model.number="item.room"
                  style="width:90%;text-align: center;" :disabled="roomDisabled" @change="roomChange(item, $event)">

              </van-col>

              <van-col span="2" class="text-center line-h20 " v-show="clothesShow">{{ item.cloth_size || '暂无' }}
              </van-col>
              <van-col span="2" class="text-center line-h20 " v-show="clothesShow">{{ item.length || '暂无' }}</van-col>
              <van-col span="2" class="text-center line-h20 " v-show="clothesShow">{{ item.weight || '暂无' }}</van-col>
              <van-col :span="clothesShow ? '4' : '5'" class="text-center line-h20" style="color:#ee0a24;">
                {{ item.mobile_no }}</van-col>
              <van-col :span="clothesShow ? '4' : '5'" class="line-h20" style="font-weight: 700;padding: 2px 0;">
                {{ item.business_name }}</van-col>
            </van-row>
            <div v-show="remarkShow" class="remark" @click="job < 5 ? onRemark(item) : ''">
              {{ item.exe_remark || item.remark || '暂无备注' }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 控制器 -->


    <!-- /控制器 -->

    <!-- 占位 -->
    <div style="height: 100px;width: 100%;"></div>
    <!-- /占位 -->
    <div class="footers">
      <div class="flex-box" style="padding:10px 0;">
        <button class="buttons cwbf" @click="remarkShow = !remarkShow">显示/隐藏备注</button>
        <button v-if="job < 4" class="buttons cwbf" @click="roomDisabled = !roomDisabled">房间</button>
        <button class="buttons cwbf" @click="clothesShow = !clothesShow">显示/隐藏营服</button>
      </div>
      <div class="flex-box">
        <button class="buttons cwbf" style="background-color: aqua;" @click="skipPhysicalState()">体温/排便</button>
        <button class="buttons cwbf" style="background-color:gold;" @click="takePillsShow = true">吃药</button>
        <button v-if="job < 4" class="buttons cwbf" style="background-color:green;" @click="tempList()">实到营员</button>
        <button v-if="job < 4" class="buttons cwbf" style="background-color: #ee0a24;"
          @click="onAbnormal()">伤病财物</button>
        <button class="buttons cwbf" style="background-color:coral;margin-left: 10px;"
          @click="goPassportOrBadge()">护照/徽章</button>
      </div>
    </div>

    <!-- 提交信息 -->
    <van-popup v-model="abnormalShow" :close-on-click-overlay="false" :closeable="true"
      :style="{ height: '85%', width: '90%' }">
      <div style="padding:  40px 10px">
        <div>
          <div class="p10-size14">
            <div class="title-s">活动名称</div>
            <div class="value-s">{{ project_info.party_title }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s">营期</div>
            <div class="value-s">{{ project_info.date_start }} - {{ project_info.date_end }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s">渠道</div>
            <div class="value-s">{{ business_name || '暂无' }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s">姓名</div>
            <div class="value-s" style="width:50%;border: 0.5px solid #f1f1f1;padding: 0 10px;">
              <van-field style="padding:0;" readonly clickable v-model="real_name" placeholder="请选择"
                @click="selectShow = true" />
            </div>
          </div>
          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;">家长电话</div>
            <div class="value-s">{{ mobile_no || '暂无' }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;">小队编号</div>
            <div class="value-s">{{ team3_info.name || '暂无' }}</div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;vertical-align: top;width: 36%;">状况</div>
            <div style="display:inline-block;width:63%;border: 0.5px solid #999;">
              <van-field type="textarea" v-model="content" placeholder="请输入状况" />
            </div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;vertical-align: top;width: 36%;">已做怎样处理</div>
            <div style="display:inline-block;width:63%;border: 0.5px solid #999;">
              <van-field type="textarea" v-model="solution" placeholder="请输入已做处理" />
            </div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;width: 36%;">是否需要支援</div>
            <div class="value-s" style="padding: 15px 10px;">
              <van-radio-group v-model="need_support" direction="horizontal">
                <van-radio name="1">是</van-radio>
                <van-radio name="0">否</van-radio>
              </van-radio-group>
            </div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;vertical-align: top;">照片</div>
            <div>
              <div class="paddingXm">
                <van-uploader :max-count="4" v-model="images" multiple :after-read="afterRead" @delete="deleteImg" />
              </div>
            </div>
          </div>

        </div>
        <div class="p10-size14">
          <button class="buttons cwbf" style="padding:10px 30px;background-color: #ee0a24;color: #fff;border: none;"
            :disabled="tijiaoShow" @click="onAffirm()">提交</button>
          <button class="buttons cwbf" style="padding:10px 30px;margin-left: 15px;border: 0.5px solid #999;"
            @click="abnormalShow = false">返回</button>

        </div>
      </div>
    </van-popup>

    <!-- 异常级别弹框 -->
    <van-popup v-model="selectShow" round position="bottom">
      <div style="padding:26px;" class="town">
        <div v-for="(item, index) in List" :key="index" class="town-item" @click="onChild(item, index)"
          :class="childIndex === index ? 'opt' : ''">
          {{ item.real_name }}
        </div>
      </div>
    </van-popup>
    <!-- /异常级别弹框 -->

    <!-- 确定提交 -->
    <van-popup v-model="affirmShow" :close-on-click-overlay="false" :style="{ height: '85%', width: '90%' }">
      <div style="padding: 20px 20px 0;font-size: 20px;text-align: center;">
        信息确认
      </div>
      <div style="padding:  20px 10px;position: relative;">

        <div>
          <div class="p10-size14">
            <div class="title-s">活动名称</div>
            <div class="value-s">{{ project_info.party_title }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s">营期</div>
            <div class="value-s">{{ project_info.date_start }} - {{ project_info.date_end }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s">渠道</div>
            <div class="value-s">{{ business_name || '暂无' }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s">姓名</div>
            <div class="value-s">
              {{ real_name }}
            </div>
          </div>
          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;">家长电话</div>
            <div class="value-s">{{ mobile_no || '暂无' }}</div>
          </div>
          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;">小队编号</div>
            <div class="value-s">{{ team3_info.name || '暂无' }}</div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;vertical-align: top;width: 36%;">状况</div>
            <div style="display:inline-block;width:63%;">
              <van-field style="padding:0;" type="textarea" v-model="content" :disabled="true" />
            </div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;vertical-align: top;width: 36%;">已做怎样处理</div>
            <div style="display:inline-block;width:63%;">
              <van-field style="padding:0;" type="textarea" v-model="solution" :disabled="true" />
            </div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;width: 36%;">是否需要支援</div>
            <div class="value-s" style="padding: 15px 10px;">
              <van-radio-group v-model="need_support" direction="horizontal" :disabled="true">
                <van-radio name="1">是</van-radio>
                <van-radio name="0">否</van-radio>
              </van-radio-group>
            </div>
          </div>

          <div class="p10-size14">
            <div class="title-s" style="color:#000;font-weight: 500;vertical-align: top;">照片</div>
            <div>
              <div class="paddingXm">
                <van-uploader :show-upload="false" :max-count="4" v-model="images" multiple :deletable="false" />
              </div>
            </div>
          </div>

        </div>
        <div class="p10-size14">
          <button class="buttons cwbf" style="padding:10px 30px;background-color: #ee0a24;color: #fff;border: none;"
            :disabled='loadingShow' @click="onSubmit()">确认提交</button>
          <button class="buttons cwbf" :disabled='loadingShow'
            style="padding:10px 30px;margin-left: 15px;border: 0.5px solid #999;" @click="onaffirmShow()">返回</button>

        </div>

        <van-loading v-show="loadingShow" style="position:absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"
          type="spinner" color="#1989fa" />
      </div>

    </van-popup>

    <van-dialog v-model="rShow" title="备注" show-cancel-button @cancel="rShow = false" @confirm="remarkConfirm()">
      <van-cell-group>
        <van-field v-model="editRemarkValue" type="textarea" autosize row="2" placeholder="请输入备注信息" />
      </van-cell-group>
    </van-dialog>

    <!-- 吃药列表 -->

    <van-popup v-model="takePillsShow" :style="{ width: '85%', height: '80%' }" round closeable
      :close-on-click-overlay="false" @click-close-icon="takePillsShow = false">
      <div style="padding:10px 8px 5px">
        <div style="padding:5px;font-size: 18px;text-align: center;font-weight: 700;">吃药列表</div>
        <div style="padding:10px 15px">
          <div v-for="(item, index) in drugsList" :key="index" style="padding:5px 0;border-bottom: 1px solid #999;">
            <div class="p10-size14">
              <div class="title-s" style="color:#000;font-weight: 500;vertical-align: top;width: 25%;text-align: left;">
                {{ item.real_name }}</div>
              <div style="display:inline-block;width:74%;word-break: break-all">
                {{ item.drug_remark }}
              </div>
            </div>
          </div>
          <div v-if="drugsList.length == 0">
            <van-empty description="暂无数据" />
          </div>

        </div>
      </div>
    </van-popup>

    <!-- /吃药列表  -->

    <!-- 孩子吃药 -->
    <van-dialog v-model="submitChildShow" title="吃药备注" :show-cancel-button="job < 5 ? true : false"
      @cancel="submitChildShow = false" @confirm="submitChildConfirm()">
      <div style="padding:5px;">
        <div style="border: 1px solid #f1f1f1;">
          <van-field v-model="submitChildValue" type="textarea" autosize row="5" :readonly="job > 4 ? true : false"
            placeholder="请输入药物信息" />
        </div>
      </div>
    </van-dialog>

    <!-- 生日弹窗 -->
    <van-dialog v-model="birthdayShow" title="生日" :show-cancel-button="false" @cancel="birthdayShow = false"
      @confirm="birthdayShow = false">
      <div style="padding:5px;">
        <div style="border: 1px solid #f1f1f1;">
          <van-field v-model="birthdayValue" type="text" input-align="center" :readonly="true" />
        </div>
      </div>
    </van-dialog>

    <!-- /生日弹窗 -->

    <!-- 实到人数弹框 -->
    <van-dialog v-model="attendanceShow" width="95%" title="实到营员" :showCancelButton="true" confirm-button-text="提交"
      @cancel="cancel()" @confirm="confirm()">
      <div style="padding:10px ;border-top: 1px solid #999;border-bottom: 1px solid #999;">
        <div class="shidao">
          <div class="name-item" v-for="(item, index) in List_temp" :key="index">
            <div style="vertical-align:  middle;display: inline-block;">
              <div style="float:right">
                <van-checkbox icon-size="16" v-model="item.arrive" @click="temlChe">
                </van-checkbox>
              </div>
            </div>
            <div style="display: inline-block;padding-left: 5px;font-size: 16px;">{{ item.real_name }}</div>
          </div>
        </div>

        <div style="padding-top: 20px;">
          <div style="vertical-align:  text-top;display: inline-block;width: 40%;text-align: right;height: 30px;">
            <div style="float:right">
              <van-checkbox v-model="arrives" @click="tempArrives(arrives)"></van-checkbox>
            </div>
          </div>
          <div style="display: inline-block;padding: 0 5px;">全选</div>
        </div>

      </div>
    </van-dialog>
    <!-- /实到人数弹框 -->

  </div>
</template>
<script>
import lrz from 'lrz'
import { Dialog, Toast } from 'vant'
export default {
  name: 'camper',
  data () {
    return {
      List: [], // 孩子列表
      List_temp: [], // 临时孩子列表
      remarkShow: false, //控制总体备注信息的显示隐藏
      clothesShow: false, //控制营服信息的显示隐藏
      roomDisabled: true, //控制是否禁用房间输入框
      abnormalShow: false, //异常信息弹层 <显示/隐藏>
      id: '', // 孩子的 id
      childId: '',
      selectShow: false,
      real_name: '', //姓名
      business_name: '', //渠道
      mobile_no: '', //家长电话

      content: '', //状况
      solution: '', //应对处理

      team2_info: {
        captain_mobile: '',
        captain_name: '',
        name: '',
        actual_num: '',
      },
      team3_info: {
        captain_mobile: '',
        captain_name: '',
        name: '',
        remark_drug: '',
        actual_num: '',
      },
      project_info: {
        date_end: '',
        date_start: '',
        party_title: '',
      },
      job: '', //职级
      need_support: '0',

      images: [],
      images2: [],
      returnButtonValue: '',
      project_id: '',
      team3_id: '',
      childIndex: '',
      affirmShow: false,
      loadingShow: false, // 加载中
      rShow: false, //备注信息相关
      editRemarkValue: '', //需要修改的备注
      team_type: '',
      takePillsShow: false, //吃药控件
      tijiaoShow: false, //提交确认\
      submitChildShow: false,
      submitChildIds: '', //吃药孩子的id
      submitChildValue: '', //吃药孩子的
      drugsList: [],
      birthdayShow: false, //生日弹窗控件
      birthdayValue: '',
      attendanceShow: false, //实到人数控件
      arrives: false,
    }
  },
  created () {
    this.project_id = this.$route.query.project_id
    this.team3_id = this.$route.query.team3_id
    this.getListInfo()
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  methods: {
    // 复制姓名
    copyName () {
      let valueList = this.List.map((item) => {
        return item.real_name
      })
      let value = ``
      for (let i = 0; i < valueList.length; i++) {
        // 这里需要将名字换行对齐
        value = value + valueList[i] + '\n'
      }
      console.log(value)
      this.$copyText(value).then(
        (e) => {
          this.$toast('复制成功')
        },
        (e) => {
          this.$toast('复制失败')
        }
      )
    },
    // 生日弹窗
    onBirthday (birthday) {
      this.birthdayValue = birthday
      this.birthdayShow = true
      console.log(birthday, 'birthday')
    },
    //吃药
    onTakePills (item) {
      this.submitChildIds = item.id
      this.submitChildValue = item.drug_remark
      this.submitChildShow = true
    },
    submitChildConfirm () {
      if (this.job > 4) {
        this.submitChildShow = false
        return
      }
      this.$axios
        .post('/project/update-remark', {
          id: this.submitChildIds,
          type: 'drug',
          remark: this.submitChildValue,
        })
        .then((res) => {
          this.$toast(res.data.msg)
          this.submitChildShow = false
          this.getListInfo()
          console.log(res, 'res')
        })
    },
    onaffirmShow () {
      this.affirmShow = false
      this.tijiaoShow = false
      this.images2 = []
    },
    // 修改备注
    onRemark (item) {
      this.editRemarkValue = item.exe_remark
      this.childId = item.id
      this.rShow = true
    },
    // 确认修改备注
    remarkConfirm () {
      this.$axios
        .post('/project/update-remark', {
          id: this.childId,
          remark: this.editRemarkValue,
        })
        .then((res) => {
          this.$toast(res.data.msg)
          this.rShow = false
          this.getListInfo()
          console.log(res, 'res')
        })
    },
    //跳转到排便
    skipPhysicalState () {
      this.$router.push({
        path: '/physicalState',
        query: {
          team_id: this.team3_id,
        },
      })
    },
    // 护照徽章
    goPassportOrBadge () {
      this.$router.push({
        path: '/sign',
        query: {
          team3_id: this.team3_id,
        }
      })
    },
    // 选择孩子
    onChild (e, index) {
      this.real_name = e.real_name
      this.childIndex = index
      this.business_name = e.business_name
      this.mobile_no = e.mobile_no
      this.id = e.id
      this.selectShow = false
    },
    // 调回到全员
    toSkip () {
      this.$router.push({
        path: '/posDetail',
        query: {
          project_id: this.project_id,
        },
      })
    },
    // 失去焦点数值改变
    roomChange (item, e) {
      let room = e.target.value
      this.$axios
        .post('/project/updateroom', {
          id: item.id,
          room: room,
        })
        .then((res) => {
          console.log(res)
          Toast(res.data.msg)
        })
    },

    // 打开伤病财物
    onAbnormal () {
      this.abnormalShow = true
    },
    async getListInfo () {
      this.drugsList = []
      const res = await this.$axios.get('/project/team3', {
        params: {
          team3_id: this.team3_id,
        },
      })
      if (res.data.code != 200) {
        this.$router.replace({
          path: '/errorPage',
          query: { msg: res.data.msg },
        })
        return
      }
      let data = res.data.data
      this.team_type = data.team_type
      if (this.team_type == 3) {
        this.returnButtonValue = '返回营期'
      } else {
        this.returnButtonValue = '返回中队'
      }

      let members = data.members
      let info = data.project_info
      for (let i = 0; i < members.length; i++) {
        members[i].remark = members[i].health + members[i].taboo
        members[i].text = members[i].real_name

        if (members[i].drug_remark) {
          this.drugsList.push(members[i])
        }
      }
      this.List = members
      this.job = data.job

      this.team2_info = data.team2_info
      this.team3_info = data.team3_info
      if (info.date_end) {
        info.date_end = this.$mUtil.timeFormat(info.date_end)
      }

      if (info.date_start) {
        info.date_start = this.$mUtil.timeFormat(info.date_start)
      }
      this.project_info = info

      let config = {
        title: `【${this.project_info.date_start}】${this.project_info.party_title}`,
        img: 'https://img.jiarixiaodui.com/jrhb-logo.jpg',
        sharePath: `/camper?project_id=${this.project_id}&team3_id=${this.team3_id}`,
      }
      this.wxShare(config)
    },
    // 上传的回调
    afterRead (e) { },
    // 删除图片相关回调
    deleteImg (e) {
      console.log(e)
    },
    onAffirm () {
      // let time = null
      if (!this.real_name) {
        this.$toast('请选择孩子')
        return
      }

      if (!this.content) {
        this.$toast('请输入状况')
        return
      }
      if (!this.solution) {
        this.$toast('请输入已做怎样处理')
        return
      }
      this.tijiaoShow = true
      for (let i = 0; i < this.images.length; i++) {
        lrz(this.images[i].content, {
          width: 600,
          height: 600,
          quality: 0.75,
        })
          .then((res) => {
            this.images2.push(res.base64)
          })
          .catch((err) => {
            console.log(err)
          })
      }
      this.affirmShow = true
    },
    onSubmit () {
      let that = this
      let timeArray = []
      let imageArray = []
      imageArray = this.images2

      if (this.id) {
        timeArray.push(this.id)
      }
      console.log(imageArray)
      // 这里打开loading
      this.loadingShow = true
      this.$axios
        .post('/project/issuereport', {
          team_id: this.team3_id,
          member_ids: timeArray,
          content: this.content,
          solution: this.solution,
          pics: imageArray,
          need_support: this.need_support,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.loadingShow = false
            Dialog.alert({
              message: '提交成功',
            }).then(() => {
              this.abnormalShow = false
              this.affirmShow = false
              this.tijiaoShow = false
              this.real_name = ''
              this.mobile_no = ''
              this.content = ''
              this.childIndex = ''
              this.business_name = ''
              this.solution = ''
              this.images = []
              this.images2 = []
            })
          }
        })
    },
    onMobile (phoneNumber) {
      console.log(phoneNumber, '手机号')
      if (phoneNumber) {
        window.location.href = 'tel://' + phoneNumber
      }
    },

    skipWork () {
      this.$router.push({
        path: '/work',
        query: {
          project_id: this.project_id,
        },
      })
    },
    toBrack () {
      if (this.team_type == 3) {
        this.$router.push({
          path: '/Position',
        })
      } else {
        this.$router.push({
          path: '/lochus',
          query: {
            team2_id: this.team2_info.id,
            project_id: this.project_id,
          },
        })
      }
    },
    onAbnormalSearch (item) {
      this.$router.push({
        path: '/abnormalSearch',
        query: {
          project_id: this.project_id,
          seachValue: item.real_name,
        },
      })
    },
    confirm () {
      let arrive_ids = []
      for (let i = 0; i < this.List_temp.length; i++) {
        if (this.List_temp[i].arrive == 1) {
          arrive_ids.push(this.List_temp[i].id)
        }
      }
      this.$axios
        .post('project/participant-arrive', {
          team_id: this.team3_id,
          arrive_ids: arrive_ids,
        })
        .then((res) => {
          this.attendanceShow = false
          this.getListInfo()
          if (res.data.code == 200) {
            this.$toast(res.data.msg)
          }
        })
    },

    cancel () {
      this.attendanceShow = false
      this.arrives = false
    },

    tempList () {
      this.List_temp = JSON.parse(JSON.stringify(this.List))
      this.attendanceShow = true
    },
    temlChe () {
      let tampVlue = this.List_temp.every((item) => {
        return item.arrive > 0
      })
      if (tampVlue) {
        this.arrives = true
      } else {
        this.arrives = false
      }
    },
    tempArrives (newV) {
      if (newV) {
        for (let i = 0; i < this.List_temp.length; i++) {
          this.List_temp[i].arrive = 1
        }
      } else {
        for (let i = 0; i < this.List_temp.length; i++) {
          this.List_temp[i].arrive = 0
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.gundong {
  border-bottom: 1px solid #f7f7f7;
  max-width: 100%;
  margin: auto;
  overflow-x: auto;
  white-space: nowrap;
  overflow-y: hidden;

  .border-ls {
    border-top: 1px solid #999;
    // border-bottom: 1px solid #999;
  }

  .border-ls:last-child {
    // border-top: 1px solid #999;
    border-bottom: 1px solid #999;
  }

}

.gundong::-webkit-scrollbar {
  display: none;
}

.acmper {
  padding: 10px 0;
  height: 100%;

  .name-item {
    padding: 5px 2px;
    display: inline-block;
    width: 32%;
  }

  .shidao {
    display: flex;
    flex-wrap: wrap;
    max-height: 400px;
    overflow-y: scroll;
    align-items: flex-start;
    justify-content: space-between;
  }

  .shidao::after {
    content: '';
    padding: 5px 2px;
    display: inline-block;
    width: 32%;
  }

}

.yichang {
  width: 100%;
  display: inline-block;
  background-color: red;
  color: #ffffff;
  text-align: center;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
}

.text-center {
  text-align: center;
  font-weight: 700;
  padding: 2px 0;
}

.remark {
  text-decoration: underline;
  table-layout: fixed;
  white-space: pre-wrap;
  overflow: hidden;
  letter-spacing: 2px;
  line-height: 20px;
  color: #666;
}

.controller {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}

.line-h20 {
  line-height: 25px;
}

.buttons {
  color: #fff;
  padding: 5px 5px;
  border: none;
  border-radius: 6px;
}

.cwbf {
  color: #000;
  background-color: #fff;
  border: 1px solid #000;
}

.p10-size14 {
  padding: 5px 10px;
  font-size: 14px;

  .title-s {
    display: inline-block;
    width: 35%;
    font-weight: 500;
    color: brown;
    text-align: center;
  }

  .value-s {
    display: inline-block;
    color: deepskyblue;
  }
}

.town {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .town-item {
    font-size: 14px;
    line-height: 22px;
    display: inline-block;
    padding: 5px 10px;
    background-color: #f1f1f1;
    width: 24%;
    margin: 5px;
    text-align: center;
    border-radius: 10px;
  }
}

.opt {
  background-color: gold !important;
  color: #fff;
}

.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;

  font-size: 13px;
  font-weight: 700;
  background-color: #fff;

  .flex-box {
    display: flex;
    justify-content: space-around;
  }


}

.vhd {
  visibility: hidden;
}
</style>